import { useModal } from '@panel/commons/hooks';
import { isMobileDevice } from '@panel/commons/helpers';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { fetchUserPermission, blockedUser } from '../../ducks/blockedUser';
import { Modal } from '../Modals';
import { BlockedModal } from './blockedModal';
import { useStepperCtx } from '../stepper';

function BlockedUserGuard() {
  const { loading, error, userStatus, blockedUserMessageKey } = useSelector(blockedUser);
  const { isShowing, toggleValue } = useModal();
  const { currentStep } = useStepperCtx();
  const { push } = useHistory();
  const isMobile = isMobileDevice();
  const location = useLocation();
  const dispatch = useDispatch();

  const idPost = new URLSearchParams(location.search).get('postingId');

  useEffect(() => {
    if (userStatus === 0 && !loading) {
      dispatch(fetchUserPermission());
    } else if ((![0, 200].includes(userStatus) || error) && !loading && !isShowing) {
      if (blockedUserMessageKey !== 'publisher.message.user.softblocked') {
        toggleValue(true);
      } else if (blockedUserMessageKey === 'publisher.message.user.softblocked' && currentStep === 4) {
        toggleValue(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStatus, currentStep]);

  const onCloseToHome = () => {
    toggleValue(false);
    if (blockedUserMessageKey === 'publisher.message.user.softblocked') {
      push(`/publicador/extras?postingId=${idPost}`);
    } else {
      window.location.href = `${window.location.origin}/panel/${!isMobile ? 'bum' : 'avisos'}`;
    }
  };

  if (isShowing) {
    return (
      <Modal>
        <BlockedModal blockedUserMessageKey={blockedUserMessageKey} error={error} onClose={onCloseToHome} />
      </Modal>
    );
  }

  return null;
}

export { BlockedUserGuard };
